// @flow
import React from "react";
import styled from "styled-components";
import { H4, P, Link, media } from "@nested/ui";
import { getConfig } from "@nested/config";
import SwooshWrapper from "../../slices/shared/Swoosh/Wrapper";

const { APP_URI } = getConfig();

const Wrapper = styled.div`
  padding: 0px 10px;
  ${media.tablet`
    padding: 0px 35px 20px;
  `};
  background-color: ${({ theme }) => theme.palette.blue.light};
`;

const Content = styled.div`
  margin: auto;
  padding: 50px 0;
  max-width: 500px;
`;

const Heading = styled(H4)`
  margin-bottom: 20px;
`;

const Text = styled(P)`
  margin-bottom: 40px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const CTA = () => (
  <SwooshWrapper colour="blue" shade="light" swoosh="Top">
    <Wrapper>
      <Content>
        <Heading center>Want to move home on your timeline?</Heading>
        <Text center>
          You can move on your timeline with Nested. You will have access to a
          cash advance to buy your new home when you find it, alongside our
          5-star rated Estate Agency service.
        </Text>
        <ButtonWrapper>
          <Link to={`${APP_URI}/get-started`} colour="white" inverted>
            Get in touch
          </Link>
        </ButtonWrapper>
      </Content>
    </Wrapper>
  </SwooshWrapper>
);

export default CTA;
